// extracted by mini-css-extract-plugin
module.exports = {"relate_read":"relate_read-1iJc1C80","arl_h4":"arl_h4-3a-s9j6p","more":"more-1NW6oTuE","r_t_t":"r_t_t-27GKEEhq","txt":"txt-Onn4Xcbn"};